var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyerProtectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2919 1.17236L19.412 4.55982V11.3347C19.412 17.1325 15.6988 22.3439 10.2919 24.624C4.88504 22.3439 1.17188 17.1325 1.17188 11.3347V4.55982L10.2919 1.17236Z",
    stroke: "black",
    strokeWidth: 2.34516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99219 12.507L8.72821 15.243L14.6562 9.31494",
    stroke: "black",
    strokeWidth: 2.34516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerProtectionIcon);
export default __webpack_public_path__ + "static/media/buyer-protection-icon.29a252b00df8a59d84e16d511b7a146b.svg";
export { ForwardRef as ReactComponent };